import styled from 'styled-components';
import {Logo} from '@internal/components';

const LogoStyled = styled(Logo)`
  align-self: flex-start;
  margin: 1rem;
`;
export default LogoStyled;
